import * as leaflet from "leaflet";
import { CursorType } from "../../../lib/runescape/CursorType";
import { LeafletUtils } from "../../../lib/gamemap/LeafletUtils";
export var RenderingUtility;
(function (RenderingUtility) {
    function interactionIcon(how, scale = 1, centered = false, cls = undefined) {
        return leaflet.icon({
            iconUrl: CursorType.meta(how).icon_url,
            iconSize: [scale * 28, scale * 31],
            iconAnchor: centered ? [scale * 14, scale * 16] : [scale * 3, 0],
            className: cls
        });
    }
    RenderingUtility.interactionIcon = interactionIcon;
    function interactionMarker(where, how, scale = 1, centered = false, cls = undefined) {
        let icon = interactionIcon(how, scale, centered, cls);
        return leaflet.marker(LeafletUtils.latLongFromVector2(where), {
            icon: icon,
            interactive: true,
        });
    }
    RenderingUtility.interactionMarker = interactionMarker;
})(RenderingUtility || (RenderingUtility = {}));
